export default __webpack_public_path__ + "376fe1ff6854554f397ef8df470036b4.png";